import { render, staticRenderFns } from "./PendingSubjects.vue?vue&type=template&id=867adb4a"
import script from "./PendingSubjects.vue?vue&type=script&lang=js"
export * from "./PendingSubjects.vue?vue&type=script&lang=js"
import style0 from "./PendingSubjects.vue?vue&type=style&index=0&id=867adb4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports